/**
 * for drilldown each year
 * @param  {array}   arr     output of subcatsInOneCnt function
 * @param  {number}  index   which year
 * @return {array}           as below
 */
/*
[
  {
    name: "Cocoa",
    id: "Cocoa",
    colorByPoint: true,
    data: [
      [
        "Cocoa beans",
        123
      ],
      [
        "Chocolates",
        123
      ],
    ]
  },
  {
    name: "Fish",
    id: "Fish",
    data: [
      [
        "Catfish",
        123
      ],
      [
        "Dogfish",
        123
      ],
    ]
  }
]
*/
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.subcatsInOneCntEachYear = subcatsInOneCntEachYear;
exports.subcatsInOneCntEachYearJustY = subcatsInOneCntEachYearJustY;

function subcatsInOneCntEachYear(arr, index) {
  var output = [];

  arr.forEach(function (d, i) {

    output[i] = {
      name: d['name'],
      id: d['id'],
      colorByPoint: d['colorByPoint'],
      data: []
    };

    var _arr = [];

    d['data'].forEach(function (dd, ii) {
      output[i]['data'][ii] = [dd[0], dd[1][index]];
    });
  });
  //console.dir(output)
  return output;
}

/*
[["Coca beans", 12], ["Chocolates", 45],...]
 */
/**
 * [subCatsInOneCntEachYearJustY description]
 * @param  {array}   arr     output of subcatsInOneCnt function
 * @param  {string}  cat     current category
 * @param  {number}  index   which year
 * @return {array}           as below
 */

function subcatsInOneCntEachYearJustY(arr, cat, index) {
  var output = [];
  arr.forEach(function (d) {
    if (d['name'] === cat) {
      d['data'].forEach(function (dd, ii) {
        output[ii] = [dd[0], dd[1][index]];
      });
    }
  });
  return output;
}
//# sourceMappingURL=data:application/json;base64,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